import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import EditIcon from '@mui/icons-material/EditRounded';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/DeleteRounded';
import ActionIconButton from '@components/ActionIconButton';
import { Typography } from '@components/Typography';
import { Card, CardFooter, CardControls, CardIconButton, CardDivider } from '@components/CardItem/styles';
import CardOwnerLabel from '@components/CardItem/OwnerLabel';
import { OWNER_TYPE } from '@components/OwnerIcon';
import { useTranslation, useHasAccessToAsset } from '@hooks';
import { RIGHTS } from '@constants/user';

const TemplateItem = ({
    data: { survey, collectedFeedbacks, views },
    companies,
    brands,
    isSubmitting,
    onClickCopy,
    onClickDelete,
    onClickEdit,
    onClickView,
    isQrOnlyPlan = false,
}) => {
    const { t } = useTranslation();
    const { hasAccessToAssetById } = useHasAccessToAsset();

    const rights = hasAccessToAssetById(survey, 'surveys');

    const locationName = survey.locationId
        ? companies?.find(company => company.companyId === survey.locationId)?.internalName
        : brands?.find(brand => brand.id === survey.brandId)?.title;

    const showResponses = !isQrOnlyPlan && survey.satisfactionSurveyEnabled;

    return (
        <Card>
            <Typography variant="subtitle2">{survey.name}</Typography>
            <CardOwnerLabel type={survey.locationId ? OWNER_TYPE.LOCATION : OWNER_TYPE.BRAND} name={locationName} />
            <CardDivider />
            <CardFooter>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography variant="caption" sx={{ color: 'var(--text-secondary)' }}>
                        {t('FeedbackSurveys.views')} <span style={{ color: 'var(--text-primary)' }}>{views ?? 0}</span>
                    </Typography>
                    {showResponses && (
                        <Typography variant="caption" sx={{ color: 'var(--text-secondary)' }}>
                            {t('FeedbackSurveys.responses')}{' '}
                            <span style={{ color: 'var(--text-primary)' }}>{collectedFeedbacks}</span>
                        </Typography>
                    )}
                </div>
                <CardControls columns={rights[RIGHTS.WRITE] ? 3 : 1}>
                    {rights[RIGHTS.WRITE] ? (
                        <>
                            <ActionIconButton
                                title={t('common.edit')}
                                component={CardIconButton}
                                disabled={isSubmitting}
                                onClick={onClickEdit}
                            >
                                <EditIcon />
                            </ActionIconButton>
                            <ActionIconButton
                                title={t('buttons.copy')}
                                component={CardIconButton}
                                disabled={isSubmitting}
                                onClick={onClickCopy}
                            >
                                <ContentCopyIcon />
                            </ActionIconButton>
                            <ActionIconButton
                                title={t('common.delete')}
                                component={CardIconButton}
                                disabled={isSubmitting}
                                onClick={onClickDelete}
                            >
                                <DeleteIcon />
                            </ActionIconButton>
                        </>
                    ) : rights[RIGHTS.READ] ? (
                        <ActionIconButton title={t('common.view')} component={CardIconButton} onClick={onClickView}>
                            <VisibilityIcon />
                        </ActionIconButton>
                    ) : (
                        <div style={{ height: '32px' }} />
                    )}
                </CardControls>
            </CardFooter>
        </Card>
    );
};

export default TemplateItem;
